import { InjectionToken } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

export const UI_ICONS_LANGUAGE_TOKEN = new InjectionToken<BehaviorSubject<string>>('Ui icons language token');
